<template>
  <div id="forgetPassword">
    <!-- 手机端注册 -->
    <div class="phone" v-if="flag == 2" v-loading="loading">
      <my_dialog
        v-if="dialogData.flag"
        :myDialogData="dialogData"
        @input="input"
        @handleClick="handleClick"
      >
      </my_dialog>
      <!-- 填写密码,再次确认密码 -->
      <makeSurePas_phone
        v-if="makeSurePasData.flag"
        :makeSurePasData="makeSurePasData"
        @reset="reset"
      ></makeSurePas_phone>
    </div>
    <!-- PC端注册 -->
    <div class="pc" v-if="flag == 1" v-loading="loading">
      <!-- 第一步填写基本信息身份证,手机号,验证码 -->
      <my_dialogPc
        v-if="dialogData.flag"
        :myDialogData="dialogData"
        @input="input"
        @handleClick="handleClick"
      >
      </my_dialogPc>
      <!-- 填写密码,再次确认密码 -->
      <makeSurePas
        v-if="makeSurePasData.flag"
        :makeSurePasData="makeSurePasData"
        @reset="reset"
        @handleClick="handleClick"
      ></makeSurePas>
    </div>
  </div>
</template>

<script>
import * as forgetPasswordData from "./forgetPassword.js";
import * as getresetDialogData from "./forgetPassword.js";
import makeSurePas from "./makeSurePas.vue";
import makeSurePas_phone from "./makeSurePas_phone.vue";

export default {
  components: { makeSurePas, makeSurePas_phone },
  data() {
    return {
      flag: 0, //手机端和pc端切换
      loading: false,
      dialogData: {
        flag: true,
        showver: true,
        yzm: false,
        suo: true,
        title: "忘记密码",
        data: forgetPasswordData.getforgetPasswordDialogData(), //数据
        btns: [
          {
            btnName: "下一步",
            active: "editPsw",
            type: "editPsw",
          },
        ],
        goBack: {
          active: "forgetPass1",
          btnName: "返回",
        },
      },
      makeSurePasData: {
        flag: false,
        title: "重置密码",
        data: getresetDialogData.getresetDialogData(), //数据
        btnName: "重置",
        goBack: {
          active: "forgetPass2",
          btnName: "返回",
        },
      },
      id: "", //学生id
    };
  },
  methods: {
    start() {
      if (window.screen.width / window.screen.height > 1) {
        this.flag = 1;
      } else {
        // this.flag = 2;
        this.$message({
          type: "warning",
          message: "请用电脑端查看!",
        });
        return;
      }
    },
    input() {
      for (let index = 0; index < this.dialogData.data.length; index++) {
        const element = this.dialogData.data[index];
        if (element.key == "phone" && element.value == "") {
          this.dialogData.yzm = false;
        } else {
          this.dialogData.yzm = true;
        }
      }
    },

    handleClick(active) {
      let requestData = {};
      switch (active) {
        /* 下一步 */
        case "editPsw":
          //
          for (let index = 0; index < this.dialogData.data.length; index++) {
            const element = this.dialogData.data[index];
            /* 非空判断 */
            if (!element.isNull && element.value == "") {
              this.$message.error(element.name + "不可为空!");
              return;
            }
            if (
              element.key == "idCard" &&
              !this.$idCardValidity.idCardValidity(element.value)
            ) {
              this.$message.error("请填写正确格式的身份证号!");
              return;
            }
            if (
              element.key == "phone" &&
              !this.$mobilePhoneNumberCheck.mobilePhoneNumberCheck(
                element.value
              )
            ) {
              this.$message.error("请填写正确格式的手机号!");
              return;
            }
            if (element.key == "idCard") {
              requestData.idCard = element.value;
            }
            if (element.key == "phone") {
              requestData.phone = element.value;
            }
            // if (element.key == "code") {
            //   requestData.code = element.value;
            // }
          }
          this.$request(
            "post",
            "/student/beforeEditPsw",
            requestData,
            (data) => {
              console.log("修改密码,后端返回学生id", data);
              this.id = data.id; //学生id
              this.dialogData.flag = false; //切换确认密码组件
              this.makeSurePasData.flag = true;
              this.loading = true;
              setTimeout(() => {
                this.makeSurePasData.flag = true;
                this.loading = false;
              }, 500);
            }
          );

          break;

        case "forgetPass1":
          this.$router.push("/");
        case "forgetPass2":
          this.makeSurePasData.flag = false;
          this.dialogData.flag = true; //切换确认密码组件

          break;

        default:
          break;
      }
    },
    //重置密码
    reset() {
      if (
        !this.makeSurePasData.data[0].isNull &&
        this.makeSurePasData.data[0].value == ""
      ) {
        this.$message.error(this.makeSurePasData.data[0].name + "不可为空!");
        return;
      }
      if (
        this.makeSurePasData.data[0].value != this.makeSurePasData.data[1].value
      ) {
        this.$message.error("两次密码不一样,请检查密码后重新输入!");
        return;
      }
      let requestData = {
        id: this.id,
        newPassword: this.makeSurePasData.data[1].value,
      };
      this.$request("post", "/student/editPsw", requestData, (data) => {
        this.$router.push("/state");
      });
    },
  },
  mounted() {
    this.start();
  },
};
</script>

<style lang="less" scoped>
#forgetPassword {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .phone {
    width: 100%;
    height: 100%;
  }
  .pc {
    width: 100%;
    height: 100%;
    background: rgba(245, 245, 245, 1);
  }
}
</style>
